<ul class="recipe">
  <li *ngFor="let product of recipe">
    <span class="recipe-product">
      <span class="recipe-product-name">{{product.product}}</span>
      <span class="recipe-product-quantity" *ngIf="product.quantity" [innerHTML]="product.quantity | safeHtml"></span>
    </span>
  </li>
</ul>
